module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid63_980x863.df713d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid63_980x863.jpg
// module id = y0Kn
// module chunks = 0